<template>
  <div class="ChangePassword">
    <div class="list">
      <div class="list-tit">门店名称</div>
      <div class="item">
        <input type="text" placeholder="请填写门店名称"  v-model="shopname"/>
      </div>
      <div class="list-tit">营业时间</div>
      <div class="item">
        <input type="text" placeholder="请填写营业时间" v-model="time"/>
      </div>
      <div class="list-tit">电话号码</div>
      <div class="item">
        <input type="number" placeholder="请填写电话号码" v-model="phone" />
      </div>
      <div class="list-tit">点击上传门店照片</div>
     <Upload @fileChange="fileChange" >
      <img :src="img" alt="" class="info">
      </Upload>
    </div>
    <div class="confirmBnt bg-color-red" @click="confirm">确认提交</div>
  </div>
</template>

<style scoped>
    .list-tit{
      font-size: .3rem;
      margin-top: .5rem;
    }
    
</style>
<script>
import { mapGetters } from "vuex";
import sendVerifyCode from "@mixins/SendVerifyCode";
import Upload from '@/components/Upload';
import { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { registerVerify, bindingPhone } from "@api/user";


export default {
  name: "ImproveInformation",
  components: {
    Upload,
  },
  props: {},
  data: function() {
    return {
      captcha: "",
      shopname:"",
      time:"",
      phone: "" //手机号
    };
  },
  mixins: [sendVerifyCode],
  computed: mapGetters(["userInfo"]),
  mounted: function() {},
  methods: {
    async confirm() {
      let that = this;
      const { phone, captcha } = that;
      try {
        await that
          .$validator({
            phone: [
              chs_phone(chs_phone.message("手机号码")),
              alpha_num(alpha_num.message())
            ],
            captcha: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ phone, captcha });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      bindingPhone({
        phone: this.phone,
        captcha: this.captcha
      })
        .then(res => {
          if (res.data !== undefined && res.data.is_bind) {
            that.$dialog.confirm({
              mes: res.msg,
              opts: [
                {
                  txt: "确认绑定",
                  color: false,
                  callback: () => {
                    bindingPhone({
                      phone: this.phone,
                      captcha: this.captcha,
                      step: 1
                    })
                      .then(res => {
                        that.$dialog.success(res.msg).then(() => {
                          that.$router.replace({ name: "PersonalData" });
                        });
                      })
                      .catch(res => {
                        that.$dialog.error(res.msg).then(() => {
                          that.$router.replace({ name: "PersonalData" });
                        });
                      });
                  }
                },
                {
                  txt: "取消",
                  color: false,
                  callback: () => {
                    that.$dialog.error("已取消绑定").then(() => {
                      that.$router.replace({ name: "PersonalData" });
                    });
                  }
                }
              ]
            });
          } else {
            that.$dialog.success(res.msg).then(() => {
              that.$router.replace({ name: "PersonalData" });
            });
          }
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    },
    async code() {
      let that = this;
      const { phone } = that;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: phone })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          that.$dialog.error(res.msg);
        });
    }
  },
  fileChange(file) {
    // 因为file是个FormData格式的对象所以可以直接通过接口开始上传，不需要做多余操作
    this.axios.post('/upload/thumb', file).then(res => {
        console.log(res.data.datas)
        this.img = this.HTTP + res.data.datas
    }, err => {
        console.log(err)
    })
},
};
</script>
